import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const InventoryReport = () => {
  const [filters, setFilters] = useState({});
  const [summary, setSummary] = useState({});
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/reports/inventory", { params: filters });
      setSummary(res.data.summary || {});
      setProperties(res.data.properties || []);
    } catch (err) {
      console.error("Failed to load inventory report", err);
      setSummary({});
      setProperties([]);
    } finally {
      setLoading(false);
    }
  };

  const download = async (type) => {
    try {
      const res = await axios.get(`/api/reports/inventory/${type}`, {
        params: filters,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `inventory-report.${type === "csv" ? "csv" : "pdf"}`);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error(`Failed to download ${type}`, err);
    }
  };

  const statusKeys = Object.keys(summary);

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Inventory Report</h4>

      <ReportFilter filters={filters} setFilters={setFilters} onSearch={fetchReport} />

      <div className="card mb-3">
        <div className="card-body d-flex justify-content-end gap-2">
          <button className="btn btn-primary" onClick={fetchReport}>
            {loading ? "Loading..." : "Search"}
          </button>
          <button className="btn btn-outline-danger" onClick={() => download("pdf")}>
            PDF Download
          </button>
          <button className="btn btn-outline-secondary" onClick={() => download("csv")}>
            CSV Download
          </button>
        </div>
      </div>

      <div className="card shadow-sm mb-3">
        <div className="card-body">
          <h6 className="fw-bold">Summary</h6>
          {statusKeys.length === 0 ? (
            <div className="text-muted">No data</div>
          ) : (
            <div className="row g-3">
              {statusKeys.map((k) => (
                <div className="col-md-3" key={k}>
                  <div className="p-3 bg-light border rounded text-center">
                    <div className="fw-bold text-uppercase small">{k}</div>
                    <div className="display-6">{summary[k]}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body table-responsive">
          <h6 className="fw-bold mb-3">By Property</h6>
          <table className="table table-bordered align-middle">
            <thead>
              <tr>
                <th>Property</th>
                <th>Area</th>
                {statusKeys.map((k) => (
                  <th key={k}>{k.toUpperCase()}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {properties.length === 0 ? (
                <tr>
                  <td colSpan={statusKeys.length + 3} className="text-center">
                    {loading ? "Loading..." : "No data"}
                  </td>
                </tr>
              ) : (
                properties.map((row) => {
                  const total = Object.values(row.statuses || {}).reduce((a, b) => a + b, 0);
                  return (
                    <tr key={row.property_id}>
                      <td>{row.property_name}</td>
                      <td>{row.area || "—"}</td>
                      {statusKeys.map((k) => (
                        <td key={k}>{row.statuses?.[k] ?? 0}</td>
                      ))}
                      <td>{total}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InventoryReport;

